import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _defineProperty2;

var _excluded = ["id", "labelText", "className"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { PrefixContext } from '../../internal/usePrefix';

var ToggleSmallSkeleton = /*#__PURE__*/function (_React$Component) {
  _inherits(ToggleSmallSkeleton, _React$Component);

  var _super = _createSuper(ToggleSmallSkeleton);

  function ToggleSmallSkeleton() {
    _classCallCheck(this, ToggleSmallSkeleton);

    return _super.apply(this, arguments);
  }

  _createClass(ToggleSmallSkeleton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          labelText = _this$props.labelText,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(PrefixContext.Consumer, null, function (prefix) {
        return /*#__PURE__*/React.createElement("div", _extends({
          className: cx("".concat(prefix, "--form-item"), className)
        }, rest), /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: id,
          className: "".concat(prefix, "--toggle ").concat(prefix, "--toggle--small ").concat(prefix, "--skeleton")
        }), /*#__PURE__*/React.createElement("label", {
          className: "".concat(prefix, "--toggle__label ").concat(prefix, "--skeleton"),
          htmlFor: id
        }, labelText && /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefix, "--toggle__label-text")
        }, labelText), /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefix, "--toggle__appearance")
        }, /*#__PURE__*/React.createElement("svg", {
          className: "".concat(prefix, "--toggle__check"),
          width: "6px",
          height: "5px",
          viewBox: "0 0 6 5"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M2.2403 2.7299L4.9245 0 6 1.1117 2.2384 5 0 2.6863 1.0612 1.511z"
        })))));
      });
    }
  }]);

  return ToggleSmallSkeleton;
}(React.Component);

_defineProperty(ToggleSmallSkeleton, "propTypes", (_defineProperty2 = {}, _defineProperty(_defineProperty2, 'aria-label', PropTypes.string.isRequired), _defineProperty(_defineProperty2, "className", PropTypes.string), _defineProperty(_defineProperty2, "id", PropTypes.string), _defineProperty(_defineProperty2, "labelText", PropTypes.string), _defineProperty2));

_defineProperty(ToggleSmallSkeleton, "defaultProps", _defineProperty({}, 'aria-label', 'Toggle is loading'));

export { ToggleSmallSkeleton as default };